module.exports = __webpack_public_path__ + "static/media/phone.5429676f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/intro-2/phone.jpg
// module id = 688
// module chunks = 0